export const startMapInitialLoad = {
  type: 'GOOGLE_MAP_INITIAL_LOAD_START'
};

export const finishMapInitialLoad = {
  type: 'GOOGLE_MAP_INITIAL_LOAD_FINISH'
};
